import React, { useState } from "react";
import { X, Loader2 } from "lucide-react";

/**
 * Create-organisation modal. Deliberately small: an organisation starts empty
 * and gets its projects and clients afterwards.
 */
const CreateOrganisationModal = ({ open, onClose, onCreate, isSaving, error }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [localError, setLocalError] = useState("");

  if (!open) return null;

  const close = () => {
    setName("");
    setDescription("");
    setLocalError("");
    onClose();
  };

  const submit = async () => {
    if (!name.trim()) {
      setLocalError("Organisation name is required.");
      return;
    }
    setLocalError("");
    const ok = await onCreate({
      name: name.trim(),
      description: description.trim(),
    });
    if (ok) {
      setName("");
      setDescription("");
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-40 z-50" onClick={close} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl z-50 w-[560px] max-w-[calc(100vw-32px)] p-8 shadow-2xl">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-[20px] font-semibold text-black">
              Create Organisation
            </h2>
            <p className="text-[13px] text-gray-500 mt-1">
              Group a client's projects and contacts in one place.
            </p>
          </div>
          <button onClick={close} aria-label="Close">
            <X size={24} className="text-black opacity-50" />
          </button>
        </div>

        <hr className="my-5" />

        {(localError || error) && (
          <div className="mb-4 p-2 bg-red-50 border border-red-200 rounded text-sm text-red-600">
            {localError || error}
          </div>
        )}

        <div className="mb-4">
          <label className="text-sm font-medium">Organisation Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Acme Corporation"
            className="w-full h-[42px] mt-1 border border-gray-300 rounded-lg px-4 text-sm outline-none"
          />
        </div>

        <div className="mb-6">
          <label className="text-sm font-medium">Description</label>
          <input
            type="text"
            value={description}
            maxLength={100}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Optional"
            className="w-full h-[42px] mt-1 border border-gray-300 rounded-lg px-4 text-sm outline-none"
          />
          <p className="text-[11px] text-gray-400 mt-1 text-right">
            {description.length}/100
          </p>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={close}
            disabled={isSaving}
            className="border border-[#4253C7] text-[#4253C7] w-[140px] h-[40px] rounded-lg text-sm disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            onClick={submit}
            disabled={isSaving}
            className="bg-[#4253C7] text-white w-[140px] h-[40px] rounded-lg text-sm flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {isSaving && <Loader2 size={14} className="animate-spin" />}
            Create
          </button>
        </div>
      </div>
    </>
  );
};

export default CreateOrganisationModal;
